<section>
  @if (visualAssets() && !visualAssetEmpty()) {
    <shared-media-component-homr-asset
      [visualAssets]="visualAssets()"
      [itemTitle]="itemTitle()"
      [imageWidthParam]="imageWidthParam()"
      [altText]="altText()"
      [prioritize]="prioritize()"
      [willLazyLoad]="shouldLazyLoad()">
    </shared-media-component-homr-asset>
  }
  @if (visualAssetEmpty() || !visualAssets()) {
    @if (youtubeId() || animation()) {
      <shared-media-component-video
        [altText]="altText()"
        [image]="image()"
        [itemTitle]="itemTitle()"
        [youtubeId]="youtubeId()"
        [animation]="animation()">
      </shared-media-component-video>
    }
    @if (!youtubeId() && !animation()) {
      <shared-media-component-scene7
        [gif]="gif()"
        [gifMobile]="gifMobile()"
        [altText]="altText()"
        [image]="image()"
        [mobileImg]="mobileImg()"
        [itemTitle]="itemTitle()"
        [imagePreset]="imagePreset()"
        [willLazyLoad]="shouldLazyLoad()">
      </shared-media-component-scene7>
    }
  }
</section>
